module.exports = __webpack_public_path__ + "img/cyber.66c5da68.jpg";